import { useEffect, useState } from "react";
import ApplyCTA from "@/components/shared/ApplyCTA";

export default function MobileStickyCTA() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > window.innerHeight * 0.4);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  return (
    <div
      className={`md:hidden fixed left-0 right-0 bottom-0 z-50 transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
        show ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="surface-glass border-t border-gold/50 p-3">
        <ApplyCTA className="w-full !min-h-[52px] !text-xs" />
      </div>
    </div>
  );
}
